import { useState, MouseEvent } from 'react'
import {
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface TableItemWithPopoverProps {
  cellValue: string
  translation: string
  aiTranslation: string
  originalTranslation: string
  helperAiTranslation: string
  helperTranslation: string
  helperOriginalTranslation: string
}

const TableItemWithPopover = ({
  cellValue,
  translation,
  aiTranslation,
  originalTranslation,
  helperAiTranslation,
  helperTranslation,
  helperOriginalTranslation,
}: TableItemWithPopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setMousePosition({ x: event.clientX + 25, y: event.clientY + 20 })
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const handleMouseMove = (event: MouseEvent<HTMLElement>) => {
    setMousePosition({ x: event.clientX + 25, y: event.clientY + 20 })
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <TableCell
        width="25%"
        align="center"
        sx={{ cursor: !!translation ? 'help' : 'default' }}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onMouseMove={handleMouseMove}
      >
        {cellValue}
      </TableCell>
      <Popover
        sx={{ pointerEvents: 'none', '.MuiPopover-paper': { borderRadius: 0 } }}
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={{ top: mousePosition.y, left: mousePosition.x }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        disableScrollLock
      >
        <TableContainer sx={{ p: 0, maxWidth: 650 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  <Typography variant="body2">
                    <HelperWrapper t="translations-popover-translation-column" />
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  <Typography variant="body2">
                    <HelperWrapper t="translations-popover-ai-translation-column" />
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  <Typography variant="body2">
                    <HelperWrapper t="translations-popover-original-translation-column" />
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  <Typography variant="body2">
                    <HelperWrapper t="translations-popover-helper-translation-column" />
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  <Typography variant="body2">
                    <HelperWrapper t="translations-popover-helper-ai-translation-column" />
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  <Typography variant="body2">
                    <HelperWrapper t="translations-popover-helper-original-translation-column" />
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  {translation ? (
                    translation
                  ) : (
                    <Typography sx={{ textAlign: 'center' }}>-</Typography>
                  )}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  {aiTranslation ? (
                    aiTranslation
                  ) : (
                    <Typography sx={{ textAlign: 'center' }}>-</Typography>
                  )}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  {originalTranslation ? (
                    originalTranslation
                  ) : (
                    <Typography sx={{ textAlign: 'center' }}>-</Typography>
                  )}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  {helperTranslation ? (
                    helperTranslation
                  ) : (
                    <Typography sx={{ textAlign: 'center' }}>-</Typography>
                  )}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  {helperAiTranslation ? (
                    helperAiTranslation
                  ) : (
                    <Typography sx={{ textAlign: 'center' }}>-</Typography>
                  )}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid black' }}>
                  {helperOriginalTranslation ? (
                    helperOriginalTranslation
                  ) : (
                    <Typography sx={{ textAlign: 'center' }}>-</Typography>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Popover>
    </>
  )
}

export { TableItemWithPopover }
